export class EventDispatcher {
    constructor() {
        this.listeners = [];
    }
    addListener(callback, checkDuplicates = false) {
        if (checkDuplicates) {
            for (const listener of this.listeners) {
                if (listener === callback) {
                    return;
                }
            }
        }
        this.listeners.push(callback);
    }
    removeListener(callback) {
        const index = this.listeners.indexOf(callback);
        if (index !== -1) {
            this.listeners.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        for (const listener of this.listeners) {
            listener(event);
        }
    }
}
//# sourceMappingURL=event-dispatcher.js.map